import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Shield } from 'lucide-react';
export function CTASection() {
  return <section id="comprar" className="py-16 px-4 bg-gradient-to-br from-navy-dark to-navy text-ice relative overflow-hidden" data-id="element-40">
      {/* Decorative background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-41" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-43">
          <ShieldCheck className="w-16 h-16 text-gold mx-auto mb-6" data-id="element-44" />

          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-ice-light mb-8" data-id="element-45">
            Adquiere el Escudo de Fe Hoy
          </h2>

          <p className="font-body text-xl md:text-2xl text-ice-dark/90 mb-10 font-light" data-id="element-46">
            No dejes que el miedo gobierne tu vida. Obtén acceso inmediato al
            "Escudo de Fe" y comienza a proteger a tu familia de la delincuencia
            y el peligro.
          </p>

          <div className="mb-6 flex flex-col items-center justify-center" data-id="element-47">
            <span className="font-body text-lg text-gold-light uppercase tracking-widest font-bold mb-2" data-id="element-48">
              Inversión en tu paz:
            </span>
            <div className="flex flex-col items-center" data-id="element-49">
              <span className="text-xl md:text-2xl text-ice/50 line-through font-heading mb-1" data-id="element-50">
                $399
              </span>
              <div className="font-heading text-5xl md:text-7xl font-bold text-white flex items-baseline gap-2" data-id="element-51">
                $138
                <span className="text-xl md:text-2xl font-body font-normal text-ice/80" data-id="element-52">
                  MXN
                </span>
              </div>
            </div>
          </div>

          {/* ¿Por qué tiene un costo? */}
          <div className="mb-10 max-w-lg mx-auto bg-white/5 backdrop-blur-sm rounded-xl p-5 border border-white/10 text-center" data-id="element-53">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-54">
              <h4 className="font-body text-sm font-bold text-gold uppercase tracking-wider" data-id="element-55">
                ¿Por qué tiene un costo?
              </h4>
            </div>
            <p className="font-body text-sm text-ice/80 leading-relaxed" data-id="element-56">
              El valor es <strong className="text-gold-light" data-id="element-57">simbólico</strong>
              . La Hermana Teresa destina lo recaudado a la mejora de la
              comunidad del monasterio. A cambio, recibes esta oración de
              protección bendecida.
            </p>
          </div>

          {/* Pulsing CTA Button */}
          <motion.a href="https://pay.hotmart.com/Q104750181Q?checkoutMode=10" whileHover={{
          scale: 1.08
        }} whileTap={{
          scale: 0.95
        }} className="animate-heartbeat w-full md:w-auto px-10 py-5 bg-gradient-to-r from-gold-light via-gold to-gold-dark text-navy-dark font-bold text-xl rounded-full transition-all duration-300 relative group overflow-hidden mb-6 inline-block" data-id="element-58">
            <span className="relative z-10 flex items-center justify-center gap-3" data-id="element-59">
              <Shield className="w-6 h-6" data-id="element-60" />
              NECESITO LA ORACIÓN HOY
            </span>
            <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12" data-id="element-61" />
          </motion.a>

          <div className="flex flex-col items-center gap-3 mt-2" data-id="element-62">
            <div className="flex items-center gap-2 text-emerald-400 font-bold uppercase tracking-wider text-sm" data-id="element-63">
              <Lock className="w-4 h-4" data-id="element-64" />
              <span data-id="element-65">Pago con seguridad bancaria</span>
            </div>
            <div className="flex flex-wrap justify-center gap-2" data-id="element-66">
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-67">
                <span className="font-bold text-[#1A1F71] text-sm italic tracking-tighter" data-id="element-68">
                  VISA
                </span>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-69">
                <div className="w-4 h-4 rounded-full bg-[#EB001B] opacity-90 z-10" data-id="element-70"></div>
                <div className="w-4 h-4 rounded-full bg-[#F79E1B] opacity-90 -ml-2" data-id="element-71"></div>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-72">
                <span className="font-bold text-[#00B1EA] text-xs" data-id="element-73">
                  mercado
                  <br data-id="element-74" />
                  pago
                </span>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-75">
                <span className="font-bold text-[#006FCF] text-xs" data-id="element-76">AMEX</span>
              </div>
              <div className="h-8 px-3 bg-white rounded-md flex items-center justify-center border border-white/20 shadow-sm" data-id="element-77">
                <span className="font-bold text-[#003087] text-sm italic tracking-tighter" data-id="element-78">
                  PayPal
                </span>
              </div>
            </div>
          </div>

          <p className="mt-8 font-body text-sm text-ice/60" data-id="element-79">
            Acceso digital inmediato. Descarga instantánea.
          </p>
        </motion.div>
      </div>
    </section>;
}